import Vue from "vue"
import vuetify from "@/plugins/vuetify"
import Filters from "@/plugins/filters"
import Notify from "@/plugins/notify"
import "@/components/_globals"
import router from "@/router"
import store from "@/store"
import i18n from "@/i18n"
import App from "@/App.vue"
import apolloProvider from "@/vue-apollo"
import Meta from "vue-meta"
import * as VueGoogleMaps from "vue2-google-maps"
import { Icon } from "leaflet"
import "leaflet/dist/leaflet.css"
import "@/registerSW"
require("@/utils/prototypes")
// this part resolve an issue where the markers would not appear
delete Icon.Default.prototype._getIconUrl
import * as moment from "moment"
Vue.prototype.$moment = moment
import "moment/locale/fr"
import "moment/locale/de"
import "moment/locale/nl"
import "moment/locale/en-gb"

Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
})

Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyBdINhYxGwaXzxkAv9YFV_k953XwS4HYig",
        libraries: "drawing",
        libraries: "places",
    },
})
Vue.use(Meta)
Vue.use(Notify)
Vue.config.productionTip = false
Vue.use(Filters)
new Vue({
    i18n,
    router,
    store,
    apolloProvider,
    vuetify,
    render: (h) => h(App),
}).$mount("#app")
